
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ErrorOverlay',
  setup () {
    const reload = () => {
      window.location.reload()
    }

    return {
      reload
    }
  }
})
